<template>
    <div id="loading" class="ui active dimmer" v-if="showModal">
        <div class="ui text loader">Loading</div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0 }
    },
    created: function() {
        this.showModal = true;
    },
    mounted: function() {
        this.$event.set("openLoading", () => { this.showModal = true; });
        this.$event.set("closeLoading", () => { this.showModal = false; });
    },
    beforeDestroyed: function() {
        this.$event.clear("openLoading");
        this.$event.clear("closeLoading");
    },
}
</script>

<style>

#loading {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue